export default { sha: '2ca16919549604e1b0d96c71475787ec4e9f71bd', buildNumber: 'undefined' }
